'use client'
import React, { useEffect, useState } from 'react';
import { Flex } from '@chakra-ui/layout';
import useInsightApi from '../insight/lib/useInsightApi';
import InsightCardList from '../insight/components/insightCardList';
import { insightTypeDictionnary } from '../insight/lib/insightTypeDictionnary';
export default function TesterPage() {
  const [lists, setLists] = useState();
  const insightApi = useInsightApi();
  const fetchData = async () => {
    try {
      const result = await Promise.all([
        insightApi.fetchAllMyActiveInsightSummaryByType(insightTypeDictionnary.negative),
        insightApi.fetchAllMyActiveInsightSummaryByType(insightTypeDictionnary.improvement)
      ])
      setLists({
        [insightTypeDictionnary.negative]: result[0],
        [insightTypeDictionnary.improvement]: result[1]
      })
    } catch (e) {
      console.error(e);
    }
  };
  useEffect(() => {
    if (!lists) {
      fetchData();
    }
  }, [])
  return (
    <Flex
      width="100%"
      height="100%"
      p={3}
    >
      <InsightCardList
        lists={lists}
        onSetAsOutdated={fetchData}
        />
    </Flex>
  )
}
